import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Input } from 'antd'
import { HiExternalLink } from 'react-icons/hi'
import { Section } from 'components/Common'
import { StepStatus } from 'hooks/useStep'
import {
  ActionCard,
  OutlineButton,
  PrimaryButton,
  OpenShipdayButton,
  FieldGroup,
  FieldLabel,
  SidePanelTitle,
  SidePanelList,
  SidePanelItem,
  SidePanel
} from './styles'
import { SHIPDAY_APP_URL } from '../../constants'
import StepLayout from '../Common/StepLayout'

interface ApiKeyStepProps {
  stepNumber: number
  loading?: boolean
  onContinue: (apiKey: string) => void
  onCancel: () => void
}

const ApiKeyStep = ({
  stepNumber,
  loading,
  onContinue,
  onCancel
}: ApiKeyStepProps) => {
  const [apiKey, setApiKey] = useState('')

  return (
    <StepLayout
      sidebar={
        <SidePanel>
          <SidePanelTitle>How to find your API key:</SidePanelTitle>
          <SidePanelList>
            <SidePanelItem>Log in to your Shipday account</SidePanelItem>
            <SidePanelItem>Go to Integrations</SidePanelItem>
            <SidePanelItem>
              Click API Credentials at the top of the left hand menu
            </SidePanelItem>
            <SidePanelItem>Copy the API key shown there</SidePanelItem>
            <SidePanelItem>Come back here to paste it</SidePanelItem>
          </SidePanelList>
        </SidePanel>
      }
    >
      <Section
        title='Add Shipday API key'
        description='Log in to Shipday and copy your API key from Integrations'
        stepStatus={StepStatus.active}
        stepNumber={stepNumber}
      >
        <FieldGroup>
          <FieldLabel htmlFor='shipday-api-key'>
            Paste Shipday API key
          </FieldLabel>
          <Input
            id='shipday-api-key'
            placeholder='e.g. sk_live_xxxxxxxxxxx'
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
          <FieldHint>
            Make sure you copy the full key. You can update this later.
          </FieldHint>
        </FieldGroup>
        <OpenShipdayButton
          href={SHIPDAY_APP_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          OPEN SHIPDAY <HiExternalLink />
        </OpenShipdayButton>
      </Section>

      <ActionCard>
        <OutlineButton onClick={onCancel}>CANCEL</OutlineButton>
        <PrimaryButton
          disabled={!apiKey.trim() || loading}
          loading={loading}
          onClick={() => onContinue(apiKey.trim())}
        >
          CONTINUE
        </PrimaryButton>
      </ActionCard>
    </StepLayout>
  )
}

const FieldHint = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #77778e;
`

export default ApiKeyStep
